import React from "react";
import { Table, TableContainer } from "@mui/material";
import PackingTableHeader from "./PackingTableHeader";
import PackingTableBody from "./PackingTableBody";

const PackingTable = ({ ...rest }) => {
  return (
    <TableContainer sx={{ height: "fit-content" }}>
      <Table>
        <PackingTableHeader />
        <PackingTableBody {...rest} />
      </Table>
    </TableContainer>
  );
};

export default PackingTable;
